import { render, staticRenderFns } from "./ConfigurarPreciosParcelas.vue?vue&type=template&id=4624fac0"
import script from "./ConfigurarPreciosParcelas.vue?vue&type=script&lang=js"
export * from "./ConfigurarPreciosParcelas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports